<template>
    <div>
        <b-modal :title="getTitleModal" modal-class="modal-primary" hide-footer @hidden="$emit('close')"
            no-close-on-backdrop no-close-on-esc v-model="show" size="xmd">


            <div class=" d-flex w-full">

                <b-table-simple ref="table-bonos-errors" small responsive table-class="" sticky-header="60vh" hover>
                    <b-thead class="w-full">
                        <b-tr>

                            <b-th class="">CATEGORIA</b-th>
                            <b-th class="">SUBCATEGORIA</b-th>
                            <b-th class="">VIAJE</b-th>
                            <b-th class="">SERVICIO</b-th>
                            <b-th class="">MONTO</b-th>
                            <b-th class="">OBSERVACIONES</b-th>

                        </b-tr>
                    </b-thead>

                    <b-tbody v-if="items.length">
                        <b-tr v-for="(item, idx) in items" :key="idx">


                            <b-td class="text-center">
                                <span style="opacity: 0.7" class="text-primary">
                                    {{ item.bono_categoria }}
                                </span>
                            </b-td>
                            <b-td class="text-center">
                                <span style="opacity: 0.7" class="text-primary">
                                    {{ item.categoria2 ? item.categoria2 : '-' }}
                                </span>
                            </b-td>

                            <!-- Estado -->
                            <b-td class="text-center">
                                {{ item.viaje ? item.viaje : '-' }}
                            </b-td>

                            <b-td class="text-center">
                                {{ item.orden ? item.orden : '-' }}
                            </b-td>
                            <b-td class="text-right">
                                <span class="d-block text-right text-primary">S/ {{ item.monto_bono | currency }}</span>
                            </b-td>

                            <b-td>
                                <p> {{ item.error_message }} </p>
                            </b-td>

                        </b-tr>
                    </b-tbody>

                </b-table-simple>
            </div>

            <div class="d-flex justify-content-end gap-x-3">
                <b-button variant="outline-primary" @click="$emit('close')">
                    <!-- :disabled="existePeriodo" -->
                    CERRAR
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";
import { getMonthByNumber2 } from "@/helpers/helpers.js";
import moment from "moment-timezone";

export default {
    components: {
        flatPickr,
    },
    props: {
        modalData: {
            type: Object,
            require: true,
        },
        categoria: {
            type: String,
            require: true,
        },

        tipo: {
            type: String,
            require: true,
        }

    },
    data() {
        return {
            show: true,
            items: []
        };
    },
    async mounted() {
        // periodos debe contener los meses del anio hasta el mes actual
        await this.getErrorsMessages();
    },
    computed: {
        ...mapGetters({
            currentUser: "auth/currentUser",
        }),
        getTitleModal() {
            return "OBSERVACIONES DE CALCULO DE BONOS : " + (this.modalData && this.modalData.nombre_completo ? this.modalData.nombre_completo : "");
        }
    },
    methods: {
        getMonthByNumber2,

        async getErrorsMessages() {
            try {
                console.log("modalData: ", this.modalData);
                const { data } = await BonoService.getErrorMessages({
                    bono_id: this.modalData.id,
                    tipo: this.tipo,
                    categoria: this.categoria
                });
                this.items = data.data || [];
            } catch (error) {
                this.items = [];
                console.log(error);
            }
        },
    },
};
</script>
